import { Component, OnInit } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ApiService } from "../services/api.service";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";

@Component({
  selector: 'app-dashboard',
    templateUrl: 'dashboard.component.html',
    styleUrls: ['dashboard.component.css']

})
export class DashboardComponent implements OnInit {

  hostInfo:any;
  userId: any;
  userName: any;
  webnarAttendList: any;
  attendInfo: any;
  getMeetingID: any;
  webinarMembersList:any;

  constructor(
    private router: Router,
    private modalService: NgbModal,
    public ApiServiceCall: ApiService
  ) {
    this.userId = localStorage.getItem('userID');
    this.userName = localStorage.getItem('userName');
    this.hostInfo = [];
    this.attendInfo = [];
    this.webinarMembersList = [];
  }

  ngOnInit(): void {
    this.getAllHostList();
    this.getAllAttendList();
  }

  
getAllHostList(){
  var obj = {userId:this.userId};
  this.ApiServiceCall.getAllHostedList(obj).subscribe((data) => {
   
    console.log(data.responseValue);
    let myData = data.responseValue;      
    for (let i=0;i<myData.length;i++)
    {
      if(myData[i]['isWebinar'] == '0')
      {
      this.hostInfo.push(myData[i]);
      }
    }
    
});

}
getAllAttendList(){
  var obj = {userId:this.userId};
  this.ApiServiceCall.getAllAttendList(obj).subscribe((data) => {
   
    console.log(data.responseValue);
    let myData = data.responseValue;  
    for (let i=0;i<myData.length;i++)
    {
      if(myData[i]['isWebinar'] == '0')
      {
      this.attendInfo.push(myData[i]);
      }
    }
    
});
}
getMembersList(webinarId){
  var obj = {id:webinarId};
    this.ApiServiceCall.getMemberOfMeetingList(obj).subscribe((data) => {
      console.log(data.responseValue);
      this.webinarMembersList = data.responseValue;
      
    });
  }
toCreateConference(){
  this.router.navigate(['/conferenceschedule']);
  // [routerLink]="['/conferenceschedule']"
}

delete(component,item) {
  this.getMeetingID=item;
  console.log('DeleteWebinar', this.getMeetingID);
  this.modalService.open(component);
}

onDeleteMeeting(){
  var obj ={
    isWebinar:1,
    id: this.getMeetingID.webinarId,
    userId:localStorage.getItem("userID")
  }
  console.log("DeleteMeeting"+ JSON.stringify(obj));
  this.ApiServiceCall.deleteWebinar(obj).subscribe((data) => {
    // this.webnarAttendList.slice(this.webnarAttendList.indexOf(this.getWebinarID),1);
    this.hostInfo.slice(this.hostInfo.indexOf(this.getMeetingID.webinarId),1);
    this.modalService.dismissAll();
    console.log(data.responseMessage);
      // alert('success');
  });
 
  
}

}
